<template>
    <div>
        <base-header type="gradient-primary" class="pb-6 pb-8 pt-5 pt-md-8">
                <!-- <h1 class="formTitle">Loan Repayment Details </h1> -->
            <i class="fas fa-arrow-left" style="font-size:20px;color:white;padding-bottom: 5px;cursor: pointer;" @click="goBack"> Back</i>
                <v-card>
                <v-card-text>
                    <div class="table-responsive" id="printMe">
          <div>
            <div style=" text-align: center">
              <h1 class="display-3 logoName">MSacco</h1>
                <img src="../../assets/logo.png" class="navbar-brand-img" alt="...">
              <h5>P.O BOX 1919, 01000</h5>
              <h5>Tel: 020678567 <span> Fax: 678457</span></h5>
              <h5>Mobile: 078923778</h5>
            </div><br>
            <div class="row justify-content-between" style="margin-left: 3%">
              <div class="col-6">
                <h5> Member No: {{loanStatement.member.member_id}} </h5>
                <h5> Member Name: {{loanStatement.member.member_names}}</h5>
                <h5> Total Shares: {{loanStatement.member.member_shares}}</h5>
                  <br>
                <h5>Statement Date: {{loanStatement.access_time}}</h5>
              </div>

            </div><br>
          </div>
          <table class="table  mb-0 table-bordered" style="text-align: center" >
            <thead class="bg-light">
            <tr>
              <th scope="col" rowspan="2">Date</th>
              <th scope="col" rowspan="2">Type</th>
              <th scope="col" colspan="2">Amount</th>
            </tr>
            <tr>
              <th scope="col">Debit</th>
              <th scope="col">Credit</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="information in loanStatement.data" :key="information.statement_public_id">
              <td>{{information.statement_date}}</td>
              <td>{{information.statement_type}}</td>
              <td>{{formatCost(information.debit)}}</td>
              <td>{{formatCost(information.credit)}}</td>
            </tr>
            <tr>
              <th colspan="2">Total</th>
              <th>{{formatCost(loanStatement.total_debit)}}</th>
              <th>{{formatCost(loanStatement.total_credit)}}</th>
            </tr>
            <tr>
              <th colspan="2">Balance</th>
              <th colspan="2">{{formatCost(loanStatement.balance)}}</th>
            </tr>
            </tbody>
          </table>
        </div> <br>
        <button type="button" class="btn btn-primary" >PRINT</button>
                 </v-card-text>
            </v-card>
        </base-header>
    </div>
</template>

<script>
    export default {
        name: "LoanRepayment",
        methods: {
            goBack(){
                this.$router.go(-1)
            },
            formatCost(amount) {
                const result = Number(amount).toLocaleString()
                if (result !== 0) {
                    return `Ksh. ${result}`;
                } else {
                    return '0';
                }
            },
        },
        created(){
          const loanPublicId = this.$route.query.loanId;
            this.$store.dispatch('viewLoanDetails_function', loanPublicId);
        }
    }
</script>

<style scoped>
    .formTitle{
        font-family: 'Dancing Script', cursive;
        text-align: center;
        padding-top: 20px;
        font-size: 40px;
        color: white;
    }
  .logoName{
        font-family: 'Dancing Script', cursive;
    }
@import url('https://fonts.googleapis.com/css?family=Dancing+Script|Satisfy&display=swap');

</style>
